import Vue from 'vue'
import Router from 'vue-router'
import routes from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'

Vue.use(Router)
const RouterLayout = createRouterLayout(layout => {
  return import('@/layouts/' + layout + '.vue')
})
routes[0].children = [
  {
    path: '/',
    component: () => import('./pages/home/home')
  }, {
    path: '/home/classification',
    component: () => import('./pages/home/classification')
  }, {
    path: '/home/community',
    component: () => import('./pages/home/community')
  }, {
    path: '/home/shoppingCar',
    component: () => import('./pages/home/shoppingCar')
  }, {
    path: '/home/itsMine',
    component: () => import('./pages/home/itsMine')
  }
]
export default new Router({
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
    }
  ]
})
